import React from "react";

import { CalloutCard, MediaCard } from "@reactivated";

import { MediaChooserBlock } from "@thelabnyc/thelabui/src/components/MediaChooserBlock";

import { ButtonTextPrimary } from "../../Clickables";
import { Svg } from "../../Svg";

import styles from "./Card.module.scss";

interface CardProps {
    value: CalloutCard | MediaCard;
}

export const Card = ({ value }: CardProps) => {
    const calloutText = "callout_text" in value ? value.callout_text : null;
    const media = "media" in value ? value.media : null;

    return (
        <article className={styles.card}>
            {calloutText ? (
                <div className={styles.number}>{calloutText}</div>
            ) : (
                media && (
                    <div className={styles.media}>
                        <MediaChooserBlock value={media} />
                    </div>
                )
            )}

            {value.headline && (
                <h3 className={styles.headline}>{value.headline}</h3>
            )}

            {value.body && <p className={styles.body}>{value.body}</p>}

            {value.link?.display_name && (
                <ButtonTextPrimary
                    simpleLink={value.link}
                    className={styles.link}
                >
                    {value.link.display_name}
                    <Svg name="arrow" />
                </ButtonTextPrimary>
            )}
        </article>
    );
};
